import React from 'react';
import Inventory from '@mui/icons-material/Inventory';

import ListPage from '../../../sharedModules/listPage/ListPage';
import { getWarehouseSelectedLocation } from '../../navigation/components/WarehouseLocationToggle';
import { receivingLogColumns } from './receivingLogColumns';
import { buildReceivingLogFilters } from './receivingLogFilters';
import { useReceivingLogChoices } from './useReceivingLogChoices';

const EMPTY_FILTERS = {};

const ReceivingLogPage: React.FC = () => {
  const location = getWarehouseSelectedLocation();
  const { receiverChoices, departmentChoices, warehouseChoices } = useReceivingLogChoices(location);

  return (
    <ListPage
      columns={receivingLogColumns}
      controller="/warehouse/receiving_logs"
      defaultSort="received_at desc"
      title="Warehouse Log"
      titleIcon={<Inventory />}
      subtitle="Receipts from both receiving apps. Updated every 15 minutes."
      additionalParams={{ location }}
      includeFilterBar
      includeQuerySearch={false}
      filterDefinitions={buildReceivingLogFilters(receiverChoices, warehouseChoices, departmentChoices)}
      defaultFilters={EMPTY_FILTERS}
      clearedFilterSetting={EMPTY_FILTERS}
    />
  );
};

export default ReceivingLogPage;
